import {
  BOTH_CART_ITEM_RECEIVED,
  CART_ITEM_ADDED,
  CART_ITEM_CLEARED,
  CART_ITEM_RECEIVED,
  CART_ITEM_REMOVED,
  CLEAR_PROMO_DETAIL,
  FINAL_CART_ITEM_ADDED,
  PRODUCT_CATEGORY_LIST_RECEIVED,
  PRODUCT_ITEM_REMOVED,
  PRODUCT_ITEM_UPDATED,
  PRODUCT_LIST_RECEIVED,
  PROMO_CODE_APPLIED,
} from "../constants/types/cartType";

const initialState = {
  activeCartItem: [],
  finalCartItems: [],
  productList: [],
  categoryList: [],
  promoDetail: null,
};

export const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case CART_ITEM_RECEIVED: {
      return {
        ...state,
        activeCartItem: action.payload,
      };
    }
    case PRODUCT_LIST_RECEIVED: {
      action.payload.forEach((element) => {
        element.quantity = element.lots.reduce(
          (sum, value) => sum + parseInt(value.quantity),
          0
        );
      });
      return {
        ...state,
        productList: action.payload,
      };
    }
    case PRODUCT_CATEGORY_LIST_RECEIVED: {
      return {
        ...state,
        categoryList: action.payload,
      };
    }
    case CART_ITEM_ADDED: {
      return {
        ...state,
        activeCartItem: state.activeCartItem.concat(action.payload),
      };
    }
    case FINAL_CART_ITEM_ADDED: {
      return {
        ...state,
        finalCartItems: state.finalCartItems
          .concat(action.payload)
          .sort((a, b) => (a.prescriptionId > b.prescriptionId ? 1 : -1)),
      };
    }

    case CART_ITEM_REMOVED: {
      return {
        ...state,
        activeCartItem: state.activeCartItem.filter(
          (x) => x.prescriptionId !== action.payload.prescriptionId
        ),
        finalCartItems: state.finalCartItems.filter(
          (x) => x.prescriptionId !== action.payload.prescriptionId
        ),
      };
    }
    case PRODUCT_ITEM_REMOVED: {
      return {
        ...state,
        activeCartItem: state.activeCartItem.filter(
          (x) => x?.productId !== action.payload.productId
        ),
      };
    }

    case PRODUCT_ITEM_UPDATED: {
      let index = state.activeCartItem.findIndex(
        (x) => x?.productId === action.payload.id
      );
      let items = JSON.parse(JSON.stringify(state.activeCartItem));
      let rate = parseFloat(items[index].total) / items[index].quantity;
      items[index].quantity = action.payload.qty;
      items[index].total = action.payload.qty * rate;
      return {
        ...state,
        activeCartItem: items,
      };
    }

    case CART_ITEM_CLEARED: {
      return {
        ...state,
        finalCartItems: [],
      };
    }
    case BOTH_CART_ITEM_RECEIVED: {
      return {
        ...state,
        activeCartItem: [],
        finalCartItems: [],
      };
    }
    case PROMO_CODE_APPLIED: {
      return {
        ...state,
        promoDetail: action.payload,
      };
    }
    case CLEAR_PROMO_DETAIL: {
      return {
        ...state,
        promoDetail: null,
      };
    }
    default:
      return state;
  }
};
